/**
 * Returns true when the error is a quota-exceeded response (BIZ_4003).
 * The global QuotaExceededModal handles these — callers should skip their own toast.
 */
export function isQuotaError(error: unknown): boolean {
  if (error && typeof error === 'object') {
    const e = error as Record<string, unknown>;
    const data = (e.response as Record<string, unknown> | undefined)?.data as
      | Record<string, unknown>
      | undefined;
    if (data?.errorCode === 'BIZ_4003') return true;
  }
  return false;
}

/**
 * Extract a human-readable error message from API errors, Axios-like wrappers,
 * or plain Error objects. Falls back to a generic message.
 */
export function getErrorMessage(
  error: unknown,
  fallback = 'Something went wrong.',
): string {
  if (error && typeof error === 'object') {
    const e = error as Record<string, unknown>;

    // Axios / fetch wrapper: error.response?.data?.message
    const response = e.response as Record<string, unknown> | undefined;
    const responseData = response?.data as Record<string, unknown> | undefined;
    if (typeof responseData?.message === 'string') return responseData.message;
    if (Array.isArray(responseData?.message)) {
      return (responseData.message as string[]).join('. ');
    }

    // Direct API envelope: error.data?.message
    const data = e.data as Record<string, unknown> | undefined;
    if (typeof data?.message === 'string') return data.message;
    if (Array.isArray(data?.message)) {
      return (data.message as string[]).join('. ');
    }

    // Plain Error: error.message
    if (typeof e.message === 'string') return e.message;
  }

  return fallback;
}
